import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChAutoCompleteComponent } from './ch-autoComplete.component';

import { FormsModule } from '@angular/forms';


export class ChAutoCompleteModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [ChAutoCompleteComponent],
  exports: [ChAutoCompleteComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
